"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatScanEventLocation = exports.formatScanEventDate = exports.formatCustomerName = void 0;
const moment_1 = __importDefault(require("moment"));
function formatScanEventLocation(location) {
    const stateAndCountry = [location.state, location.country]
        .filter((x) => !!x)
        .join(', ');
    return [location.city, stateAndCountry].filter((x) => !!x).join(' ');
}
exports.formatScanEventLocation = formatScanEventLocation;
function formatScanEventDate(date) {
    return (0, moment_1.default)(date).format('MMMM D [at] h:mma');
}
exports.formatScanEventDate = formatScanEventDate;
function formatCustomerName(customer) {
    if (!customer) {
        return 'N/A';
    }
    return [customer.firstName, customer.lastName].filter((x) => !!x).join(' ');
}
exports.formatCustomerName = formatCustomerName;
